import { EmailConsentScreenProps, EmailConsentWithRedirectScreenProps } from '@packages/shared/core/quiz/entities';
import Button from '@packages/shared/core/common/components/common/Button';
import Image from '@packages/shared/core/common/components/common/Image';
import Header from '@packages/shared/core/common/components/layout/Header';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import { prepareHtml } from '@packages/shared/core/common/utils/prepareHtml';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import styles from './EmailConsentScreen.module.scss';

const EmailConsentScreen = ({
  onSubmit,
  onBack,
  goNext,
  content,
}: EmailConsentScreenProps | EmailConsentWithRedirectScreenProps) => {
  const submitConsentAndRedirect = async (value: boolean) => {
    await onSubmit(value);
    await goNext();
  };

  return (
    <>
      <div className={styles.background} />

      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Header className={styles.header} menuClassName={styles.menu}>
            <ButtonBack className={styles.back} secondary onClick={onBack} />
          </Header>

          <div className={styles.content}>
            <Image src={content.titleImage.src} width={140} height={140} layout="fixed" alt={content.titleImage.alt} />

            <h2 className={styles.title}>{content.title}</h2>

            <p className={styles.text} dangerouslySetInnerHTML={prepareHtml(content.firstParagraph)} />

            {content.secondParagraph && (
              <p className={styles.text} dangerouslySetInnerHTML={prepareHtml(content.secondParagraph)} />
            )}

            <div className={styles.buttonsSection}>
              <Button
                data-testid={DataTestId.ACCEPT_EMAIL_UPDATES_BUTTON}
                wrapperClassName={styles.buttonWrapperAgree}
                className={styles.agree}
                onClick={() => submitConsentAndRedirect(true)}
              >
                {content.continueButtonText}
              </Button>

              <Button
                data-testid={DataTestId.REJECT_EMAIL_UPDATES_BUTTON}
                wrapperClassName={styles.buttonWrapperDisagree}
                className={styles.disagree}
                onClick={() => submitConsentAndRedirect(false)}
              >
                {content.skipButtonText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailConsentScreen;
